/**
 * Misma lógica que la sección Campaña (CampaignContent): cuatro pilares,
 * con entregables operativos integrados en cada uno.
 */
const productsData = [
  {
    id: 'estetica-estudio',
    title: 'Estética audiovisual (en estudio)',
    product: 'Producción TNO · formato híbrido TV / podcast (streaming)',
    investment: 'Incluido en plan mensual',
    impacts: [
      'Todo en ecosistema TNO Network: iluminación y atmósfera de Expedientes del Delito.',
      'Danimar en el set como pieza de evidencia; tono de periodismo de investigación.',
      '2 reels mensuales en estudio con estética cinematográfica (alto impacto visual en redes).',
    ],
  },
  {
    id: 'frases-streaming',
    title: 'Frases de autoridad (historias)',
    product: 'Streaming 24/7',
    investment: 'Incluido en plan mensual',
    impacts: [
      '3 historias semanales con las frases de Angélica Lugo (firmeza y veredicto) y Santiago Gutiérrez (cadencia y expediente).',
      'Queda para siempre en el programa: historias y piezas integradas a la biblioteca permanente del show en TNO Network.',
      'Misma narrativa de campaña: intriga, contundencia y resolución profesional.',
    ],
  },
  {
    id: 'micro-expediente',
    title: 'Micro «Expediente Danimar» (autoridad dual)',
    product: 'Expedientes del Delito · programa ancla',
    investment: 'Incluido en plan mensual',
    impacts: [
      'Una presencia en el set por emisión del programa (una vez por programa), con producto integrado según el guion de campaña.',
      'Inserts de marca en la emisión del programa (piezas audiovisuales en la puesta al aire).',
      'Logo de Danimar de forma permanente en el mini-site de Expedientes del Delito en TNO Network.',
      'Apertura (Angélica), desarrollo (Santiago) y cierre en dúo: “Danimar. Porque tu hogar merece justicia.”',
      'Voces que validan la marca como solución técnica frente a la audiencia del programa.',
    ],
  },
  {
    id: 'tno-digest-seo',
    title: 'TNO Digest y SEO: el informe técnico',
    product: 'Contenido editorial · autoridad orgánica',
    investment: 'Incluido en plan mensual',
    impacts: [
      '2 informes de peritaje al mes redactados por Angélica Lugo (no reseña genérica): datos de rendimiento y efectividad.',
      'Titular SEO sugerido: “Danimar: El informe técnico de Angélica Lugo sobre la eliminación total de residuos”.',
      'Posicionamiento en Google como autoridad en limpieza en Venezuela.',
    ],
  },
];

export default productsData;
